import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WhatsAppParamsConverter } from '../../../../shared/pipes/whatsapp-params.pipe';

@Component({
  selector: 'app-director-approval-redirect',
  standalone: true,
  template: 'Redirect',
})
export class DirectorApprovalRedirectComponent implements OnInit {
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);

  readonly whatsappParamPipe: WhatsAppParamsConverter = new WhatsAppParamsConverter();

  ngOnInit(): void {
    const encoded = this.route.snapshot.paramMap.get('whatsappApproval');
    let params: object = {};
    if (encoded) {
      params = this.whatsappParamPipe.transform(encoded);
    }
    this.router.navigate(['sign-up/director-approval'], {
      queryParams: params,
    });
  }
}
